import React from 'react'
import PropTypes from 'prop-types'
import { AppContextProvider,  ThemeProvider} from "@findep/microfronts-core"
import {afiTheme} from "../themes"
import { createMuiTheme as createTheme } from '@material-ui/core/styles'
import {  CssBaseline} from '@material-ui/core';
function ProvidersConfigLayout({ companyName, children, appContext, estado }) {
  
  const { locale } = appContext

  return (
    <AppContextProvider appContext={{ ...appContext, companyName }} >
      <ThemeProvider theme={createTheme(afiTheme, locale)}>
        <CssBaseline />
          {children}
      </ThemeProvider>
    </AppContextProvider >
  )
}

ProvidersConfigLayout.propTypes = {
  companyName: PropTypes.oneOf(['AEF', 'AFI', 'FISA', 'PRESTASUMA', 'CREDICONSTRUYE', 'PRESTAUNICO', 'FINDEP']).isRequired,
  children: PropTypes.node.isRequired,
}

export default ProvidersConfigLayout

